import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import moment from 'moment';

import PriceBreakdown from '../../global/booking-price-breakdown-component';
import BookingDisputeModalComponent from './booking-dispute-modal-component';

import { getBooking, updateBooking } from '../../dashboard/bookings/actions'


const mapStateToProps = state => ({
  booking: state.Booking,
  global: state.Global
});

function formatAsCurrency(value) {
  return isNaN(value) ? '-' : '$' + Math.abs(Number(value) / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

class AdminBookingDetailComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      disputeModalOpen: false
    }

    this.disputeDeposit = this.disputeDeposit.bind(this);
    this.openDisputeModal = this.openDisputeModal.bind(this);
    this.closeDisputeModal = this.closeDisputeModal.bind(this);
    this.fetchBooking = this.fetchBooking.bind(this);
  }

  fetchBooking() {
    let { booking, dispatch, match } = this.props;
    if (!booking.selectedBooking || booking.selectedBooking._id !== match.params.id) {
      dispatch(getBooking(match.params.id));
    }
  }

  componentWillMount() {
    this.fetchBooking();
  }

  componentDidUpdate(prevProps) {
    this.fetchBooking();
  }

  openDisputeModal() {
    this.setState({ disputeModalOpen: true });
  }
  closeDisputeModal() {
    this.setState({ disputeModalOpen: false });
  }
  disputeDeposit() {
    let { dispatch, booking } = this.props;
    booking.selectedBooking.bookingPaymentStatus = 'Disputed';
    dispatch(updateBooking(booking.selectedBooking));
    this.closeDisputeModal();
  }

  renderTransactions(transactions) {
    if (!transactions || !transactions.length)
      return (<h4>No Transactions</h4>);
    return (<table className="table admin-booking-detail-table">
      <thead>
        <tr>
          <th colSpan='2' />
          <th colSpan='2' className="text-center">Amount</th>
          <th colSpan='2' />
        </tr>
        <tr>
          <th>Transaction ID</th>
          <th>Type</th>
          <th>Service Fees</th>
          <th>Total</th>
          <th>Time</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {transactions.map((t, i) => {
          return (<tr key={`${t.blueSwipeId}_${i}`}>
            <td>{t.blueSwipeId}</td>
            <td>{t.type}</td>
            <td>{t.serviceFee < 0 ? '-' : ''}{formatAsCurrency(t.serviceFee)}</td>
            <td>{formatAsCurrency(t.amount)}</td>
            <td>{moment.utc(t.created).local().format('YYYY-MM-DD hh:mm:ss')}</td>
            <td>{t.status}</td>
          </tr>)
        })}
      </tbody>
    </table>

    )
  }

  render() {
    let { booking, history } = this.props;
    if (!booking.selectedBooking) return (<div>Loading...</div>);
    let startDate = moment(booking.selectedBooking.startDate);
    let endDate = moment(booking.selectedBooking.endDate);
    let numDays = Math.ceil(endDate.diff(startDate, 'd', true));
    let depositVoid = booking.selectedBooking.transactions.filter(txn => txn.type === 'deposit' && txn.status === 'void')[0];
    let showDisputeButton = (booking.selectedBooking.bookingPaymentStatus === 'Paid' && moment().isSameOrAfter(startDate, 'd') && !depositVoid)
    return (<div className="container dashboard-booking-overview">
      <div className="row">
        <div className="col mb-3 d-lg-flex align-items-baseline">
          <h2>Booking Overview</h2>
          <div className="pl-2">({booking.selectedBooking._id})</div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-4 mb-3">
          <div><h3>Stay</h3></div>
          <div className="pl-2"><strong>Travel Dates: </strong> {startDate.format("M/D")} - {endDate.format("M/D")} ({numDays} nights)</div>
          <div className="pl-2"><strong>Renter:</strong> {booking.selectedBooking.userId.firstName} {booking.selectedBooking.userId.lastName}</div>
          <div className="pl-2"><strong>Number of Guests: </strong> {booking.selectedBooking.numGuests}</div>
        </div>
        <div className="col-lg-4 mb-3">
          <div><h3>Listing</h3></div>
          <div className="pl-2"><strong>Title:</strong> {booking.selectedBooking.listingId.listingName}</div>
          <div className="pl-2"><strong>Owner:</strong> {booking.selectedBooking.listingId.userId.firstName} {booking.selectedBooking.listingId.userId.lastName}</div>
          <div className="pl-2"><Link to={`/listing/${booking.selectedBooking.listingId._id}`}>View Listing</Link></div>
        </div>
        <div className="col-lg-4 mb-3">
          <div><h3>Status</h3></div>
          <div className="pl-2"><strong>Request Status: </strong> {booking.selectedBooking.bookingRequestStatus}</div>
          <div className="pl-2"><strong>Payment Status:</strong> {booking.selectedBooking.bookingPaymentStatus}</div>
        </div>
      </div>


      <div className="row">
        <div className="col mb-3">
          <div><h3>Transactions</h3></div>
          <div className="pl-2">{this.renderTransactions(booking.selectedBooking.transactions)}</div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <PriceBreakdown booking={booking.selectedBooking} type="renter" />
        </div>
        <div className="col-md-6">
          <PriceBreakdown booking={booking.selectedBooking} type="owner" />
        </div>
      </div>
      <div className="button-row row mt-3">
        <div className="col text-left">
          <label onClick={() => history.goBack()}>Back</label>
        </div>
        <div className="col text-right">
          {showDisputeButton && (<button className="btn btn-secondary" onClick={this.openDisputeModal}>Dispute Deposit</button>)}
        </div>
      </div>
      {this.state.disputeModalOpen && (<BookingDisputeModalComponent onSubmit={this.disputeDeposit} onClose={this.closeDisputeModal} />)}
    </div>);

  }
}


export default withRouter(connect(mapStateToProps)(AdminBookingDetailComponent));
